"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toRedeemInfo = void 0;
const FlowConfig_1 = __importDefault(require("@/class/FlowConfig"));
const utils_1 = require("@/config/utils");
const router_1 = __importDefault(require("@/pages/index/router"));
const redeemFlowConfig = new FlowConfig_1.default({
    list: [
        'ufo_cs_sh_10',
        'ufo_cs_sh_20',
        'ufo_cs_sh_30',
        'ufo_cs_sh_40',
        'ufo_cs_sh_50',
        'ufo_cs_sh_60',
        'ufo_cs_sh_70',
        'ufo_cs_sh_80', // 结束
    ]
});
redeemFlowConfig.getList = function (flowKey) {
    let index = this.$list.indexOf(flowKey);
    if (index > 0) {
        if (index > 3) {
            index = 3;
        }
        return [...this.$list.slice(index)];
    }
    else {
        return [...this.$list];
    }
};
const toRedeemInfo = function (redeemId, overdueRecordOrFlowId, flowKey) {
    if (flowKey === 'start') {
        flowKey = redeemFlowConfig.getBuild();
    }
    else if (flowKey === 'end') {
        flowKey = redeemFlowConfig.getEnd();
    }
    router_1.default.push(`/handle/redeem/info/${redeemId}/${(0, utils_1.simpleEncrypt)(overdueRecordOrFlowId)}/${(0, utils_1.simpleEncrypt)(flowKey)}`);
};
exports.toRedeemInfo = toRedeemInfo;
exports.default = redeemFlowConfig;
